//import "jquery";
//import "./ui-select";
//import "select2";
var $ = require('jquery');
require("jquery-mousewheel")($);
require('malihu-custom-scrollbar-plugin')($);

export default function () {

  return {
    restrict: "EA",
    scope: {
      onSelect: "&?"
    },
    //templateUrl : "modules/common/directives/portlet/portlet.tpl.html",
    link: function (scope, elem, attrs) {
      var e = $(elem).dcSelect({
        mode: "multiple"
      });
      var e2 = $(elem).select2();
    }
  };

};



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-select/dc-select-multi.js